<!--
 * @Description: 顶栏（白色 48px）：折叠按钮 / 页签 / 用户中心（2026-11 改版）
 * @FilePath: /sunpay-web/src/components/layout/LayoutHeader.vue
-->
<template>
  <div class="layout-header">
    <button class="icon-btn collapse-btn" :title="collapsed ? '展开菜单' : '折叠菜单'" @click="$emit('toggle-collapse')">
      <el-icon :size="16">
        <Fold v-if="!collapsed" />
        <Expand v-else />
      </el-icon>
    </button>
    <visited-views></visited-views>
    <div class="header-spacer"></div>
    <div class="extra-info">
      <!-- 个人中心 start -->
      <el-popover
        placement="bottom-end"
        trigger="click"
        width="300"
        :show-arrow="false"
        popper-style="padding: 0"
      >
        <template #reference>
          <div class="user-center-entrance">
            <div class="avatar">{{ avatarText }}</div>
            <span class="user-name">{{ $store.state?.user?.userName }}</span>
            <el-icon class="tm-icon-xia" :size="12">
              <ArrowDown />
            </el-icon>
          </div>
        </template>
        <div class="user-center">
          <div class="ava-box">
            <img src="@/assets/imgs/ava.png" alt="">
          </div>
          <div class="login-time login-name">{{ $store.state?.user?.userName }}</div>
          <div class="login-time">最近登录时间：{{ $store.state?.user?.lastLoginTime }}</div>
          <ul>
            <li @click="showUserInfo" class="logout-li">个人配置</li>
            <li @click="handleLogout" class="logout-li">
              <i class="iconfont tm-icon-tuichudenglu"></i>
              注销
            </li>
          </ul>
        </div>
      </el-popover>
      <!-- 个人中心 end-->
    </div>
  </div>
</template>
<script setup>
import { computed, inject } from "vue"
import { ArrowDown, Fold, Expand } from "@element-plus/icons-vue"
import { editUser } from "@/views/users/components/dialogs";
import VisitedViews from "@/components/layout/VisitedViews"
import { logout } from "@/api/login"
import { useRouter } from "vue-router"

defineProps({
  collapsed: {
    type: Boolean,
    default: false,
  },
})
defineEmits(["toggle-collapse"])

const $router = useRouter()
const $store = inject("$store")

const avatarText = computed(() => {
  const name = $store.state?.user?.userName || ""
  return name ? name.slice(0, 1) : "U"
})

const handleLogout = () => {
  logout()
    .then(() => {
      $router.push("/login")
      $store.dispatch("logout")
    })
    .catch(() => {})
}

const showUserInfo = () => {
  editUser({
    record: $store?.state?.user,
    config: {
      flag: true
    }
  }).then(
    () => {
    },
    () => {}
  );
}
</script>
<style lang="less" scoped>
.layout-header {
  width: 100%;
  height: @header-height;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px 0 4px;
}
.collapse-btn {
  flex: 0 0 auto;
}
.icon-btn {
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  border-radius: @radius-s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: @text-secondary;
  cursor: pointer;
  &:hover {
    background: @bg-page;
    color: @text-primary;
  }
}
.header-spacer {
  flex: 1;
}
.extra-info {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}
.user-center-entrance {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: @radius-s;
  &:hover {
    background: @bg-page;
  }
  .avatar {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: @primary;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .user-name {
    font-size: 13px;
    color: @text-primary;
    max-width: 120px;
    .toe();
  }
  .tm-icon-xia {
    color: @text-placeholder;
  }
}

.user-center {
  > ul > li {
    height: 42px;
    line-height: 42px;
    position: relative;
    cursor: pointer;
    width: 50%;
    text-align: center;
    font-size: 13px;
    color: @text-primary;
    &:hover {
      background: @bg-page;
      color: @primary;
      & > .iconfont {
        color: @primary;
      }
    }
  }
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 6px;
  }
  .ava-box {
    width: 100%;
    text-align: center;
    padding: 16px 0 10px;
    background: @bg-page;
    margin-bottom: 8px;
    img {
      width: 40px;
    }
  }
  .login-time {
    padding: 2px 20px;
    text-align: center;
    color: @text-secondary;
    font-size: 12px;
  }
  .login-name {
    color: @text-primary;
    font-size: 14px;
    font-weight: 600;
  }
  .logout-li {
    border-top: 1px solid @border-color-light;
    .iconfont {
      margin-right: 4px;
    }
  }
  li > .iconfont:not([class*="-xiala"]) {
    color: @text-primary;
    font-size: 16px;
    vertical-align: middle;
  }
}
</style>
